import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api, { apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import AIPanel from "../components/AIPanel";
import { ArrowLeft, BookOpen } from "lucide-react";
import { toast } from "sonner";

export default function DevotionalDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get(`/devotionals/${id}`).then((r) => setD(r.data)).catch((e) => toast.error(apiError(e)));
    if (user && user.role !== "admin") api.post(`/devotionals/${id}/read`).catch(() => {});
  }, [id, user]);

  if (!d) return <p className="text-[#615A50]">Opening devotional…</p>;

  return (
    <div className="max-w-3xl mx-auto space-y-8">
      <button onClick={() => navigate("/devotionals")} className="inline-flex items-center gap-1 text-sm text-[#615A50] hover:text-[#3D5844]">
        <ArrowLeft className="w-4 h-4" /> All devotionals
      </button>

      <div className="fade-up">
        <div className="flex items-center gap-2 text-[#6B4A38] text-sm"><BookOpen className="w-4 h-4" /> {d.scripture_ref}</div>
        <h1 className="font-heading text-5xl text-[#2A2621] mt-2">{d.title}</h1>
        <p className="text-sm text-[#615A50] mt-2">{d.date ? new Date(d.date).toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" }) : ""} · {d.author_name}</p>
      </div>

      {d.scripture_text && (
        <blockquote className="rounded-2xl border-l-4 border-[#C46B4E] bg-[#F3EFE4] p-6">
          <p className="font-heading text-2xl text-[#2A2621] leading-snug italic">"{d.scripture_text}"</p>
          <p className="mt-3 text-sm font-medium text-[#6B4A38]">{d.scripture_ref} (KJV)</p>
        </blockquote>
      )}

      <div className="prose-none text-[#2A2621] leading-relaxed whitespace-pre-wrap text-[17px]">{d.body}</div>

      <div>
        <h2 className="font-heading text-3xl text-[#2A2621] mb-2">Reflect & Pray</h2>
        <p className="text-[#615A50] mb-5">Let the Word settle in your heart with these gentle, Spirit-led prompts.</p>
        <AIPanel title="Reflection & Prayer Prompts" description="Scripture-based prompts to draw you closer to Christ."
          endpoint="/ai/reflection-questions" payload={{ book_title: d.scripture_ref || d.title }} testid="ai-devotional-reflection" />
      </div>
    </div>
  );
}
